import React from 'react';
import { Wrapper } from './MobileNavigationItem.style';

interface MobileNavigationItemProps {
  label: React.ReactNode;
  link: string;
  onClick?: () => void;
}

export const MobileNavigationItem: React.FC<MobileNavigationItemProps> = ({
  label,
  link,
  onClick,
}) => {
  return (
    <Wrapper>
      <a href={link} onClick={onClick}>
        {label}
      </a>
    </Wrapper>
  );
};
